import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";

const Edit = () => {
  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Plannig in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar Plannig
          </a>
        </div>
        <div className="float-right mt-0">
          <button id="edit_beheereenheid" className="btn-sm btn-success">
            Opslaan
          </button>
        </div>
        <div className="float-right mt-0 w-20">
          <button id="return-detail" className="btn-sm btn-light">
            Annuleren
          </button>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-6 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam Beheereenheid</div>
            <div className="box-title-2-active">
              <input id="e-algemeenNaam" />
            </div>
          </div>
        </div>
        <div className="col-lg-6 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code Beheereenheid</div>
            <div className="box-title-2">
              <input id="e-algemeenCode" />
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-sm-6">
          <div className="inp-labl">Start horizon</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="date"
              className="form-control inp-h inpp"
              id="e-startDate"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="inp-labl">Eind horizon</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="date"
              className="form-control inp-h inpp"
              id="e-endDate"
            />
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="inp-labl"></div>
        <div className="input-group">
          <br />
          <input type="checkbox" id="e-beheereenheid_active" name="is_active" />
          <label htmlfor="is_active"> &nbsp; Actief</label>
          <input hidden="true" id="e-identification" />

          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default Edit;
